import { render, staticRenderFns } from "./ItemsScroller.vue?vue&type=template&id=6d9e1e6a&scoped=true"
import script from "./ItemsScroller.vue?vue&type=script&lang=js"
export * from "./ItemsScroller.vue?vue&type=script&lang=js"
import style0 from "./ItemsScroller.vue?vue&type=style&index=0&id=6d9e1e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e1e6a",
  null
  
)

export default component.exports